import React, {
    useState
} from 'react';

import { 
   IonPage,
   IonHeader,
   IonContent,
   IonToolbar,
   IonTitle,
   IonGrid,
   IonRow,
   IonCol,
   IonButtons,
   IonButton,
   IonBackButton,
   NavContext,
   IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardContent,
    IonCardTitle
} from '@ionic/react';

import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";

import '../pages/Main.css'; 

interface NumInputProp {
    amount : string;
    caption : string;
    button : string;
    onSubmit : any;
    onChange : any;
    deci : boolean;
}

const NumInputCtrl : React.FC<NumInputProp> = ({ amount, caption, button, onSubmit, onChange, deci }) => {
    
    const [index, setIndex] = useState(0);
    
    // display the number
    const setNum = (val : string) => {
        if (val == "0" && index == 0)
            return;

        let amountVal = "" + amount;
        if (amountVal.indexOf(".") > 0)
        {
            if ((amountVal.length - amountVal.indexOf(".")) > 2)
                return;
        }

        if (index == 0) {
            onChange(val);
            setIndex(1);
        } 
        else
        {
            onChange(amount + val);
            setIndex(index + 1);
        }
    }

    // clear one digit
    const setBack = () => {
        if (index <= 1) {
            onChange("0");
            setIndex(0);
        } 
        else {
            onChange(amount.substr(0, index-1));
            setIndex(index-1);
        }
    }

    // add a decimal
    const setDeci = () => {
        if (amount.indexOf(".") < 0)
        {
            if (index <= 0)
            {
                onChange(amount + ".");
                setIndex(index + 2);
            }
            else
            {
                onChange(amount + ".");
                setIndex(index + 1);
            }
        }
    }

    // check whether input is valud
    const inputValid = () : boolean => {
        var val = parseFloat(amount);
        var validNum : boolean = val > 0;
        return !validNum;
    }

    return (
        <IonCard className="flat-card">
            <IonCardHeader>
                <IonCardSubtitle>{ caption }</IonCardSubtitle>
                <IonCardTitle><h1><div className="ion-text-center">{amount}</div></h1></IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                <IonGrid>
                    { /* number pad */ }
                    <IonRow>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("1") }} >
                                <h1>1</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("2") }}>
                                <h1>2</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("3") }}>
                                <h1>3</h1>
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("4") }}>
                                <h1>4</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("5") }}>
                                <h1>5</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("6") }}>
                                <h1>6</h1>
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("7") }}>
                                <h1>7</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("8") }}>
                                <h1>8</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("9") }}>
                                <h1>9</h1>
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                            { 
                                deci ?
                            <IonButton color="primary" expand="block" fill="clear" onClick={setDeci} >
                                <h1>.</h1>
                            </IonButton>
                                :
                            <div/>
                            }
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("0") }}>
                                <h1>0</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={setBack} >
                                { GetStr(LANGUAGE.TXT_DEL) }
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                    <IonRow className="ion-padding-top">
                        <IonCol>
                            <IonButton className="main-but" color="primary" expand="block" onClick={onSubmit} disabled={inputValid()} >
                                { button }
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                </IonGrid>
            </IonCardContent>
        </IonCard>
    );
}

export default NumInputCtrl;